import React, { useEffect, useRef, useState } from 'react'
import Header from '../components/Header'
import LeftComponent from '../components/LeftComponent'
import { useDispatch, useSelector } from 'react-redux'
import { createInvoice, listInvoices } from '../actions/invoiceActions'
import { invoiceDetailJson, invoiceJson } from '../models/invoiceModel'
import Contacts from '../components/Contacts'
import Deals from '../components/Deals'
import Applications from '../components/Applications'
import "react-datepicker/dist/react-datepicker.css"
import TermListComponent from '../components/TermListComponent'
import ModalPopup from '../components/ModalPopup'
import { format } from 'date-fns'

export default function VasScreen() {
    const dispatch = useDispatch();
    const [symbol, setSymbol] = useState("$");

    const [invoicedata, setinvoicedata] = useState(invoiceJson)
    const [invoicedetails, setinvoicedetails] = useState(invoiceDetailJson)

    const [gstperc, setgstperc] = useState(0)

    const [includeGst, setIncludeGst] = useState(false)
    const [includeGstShow, setIncludeGstShow] = useState(false)
    const [gstStatus, setGstStatus] = useState(false)

    const [ocincludeGst, setocIncludeGst] = useState(false)
    const [ocincludeGstShow, setocIncludeGstShow] = useState(false)
    const [ocgstStatus, setocGstStatus] = useState(false)

    const [ocincludeGst1, setocIncludeGst1] = useState(false)
    const [ocincludeGst1Show, setocIncludeGst1Show] = useState(false)
    const [ocgstStatus1, setocGstStatus1] = useState(false)

    const [ocincludeGst2, setocIncludeGst2] = useState(false)
    const [ocincludeGst2Show, setocIncludeGst2Show] = useState(false)
    const [ocgstStatus2, setocGstStatus2] = useState(false)

    const [calculateFlag, setcalculateFlag] = useState(false)

    const [oc1, setoc1] = useState(false)
    const [oc2, setoc2] = useState(false)

    const [tfCollected, settfCollected] = useState(false)
    const [efCollected, setefCollected] = useState(false)
    const [mfCollected, setmfCollected] = useState(false)

    const [searchKeyword, setSearchKeyword] = useState("");

    const invoiceCreate = useSelector((state) => state.invoiceCreate)
    const { loading, success, error } = invoiceCreate

    const invoiceList = useSelector((state) => state.invoiceList)
    const { invoices } = invoiceList

    const handleInvoiceValue = (e) => {
        setcalculateFlag(true)
        setinvoicedata({ ...invoicedata, [e.target.name]: e.target.value, Invoice_Type_Id: '1' })
    }

    const handleInvoiceDetailValue = (e) => {
        setcalculateFlag(true)

        if (e.target.name === 'Gst_C') {
            setGstStatus(!gstStatus);
            if (e.target.checked) {
                setIncludeGstShow(true)
                setinvoicedetails({ ...invoicedetails, [e.target.name]: 1 })
            } else {
                setIncludeGstShow(false)
                setinvoicedetails({ ...invoicedetails, [e.target.name]: 0 })
            }
        } else if (e.target.name === 'OC_Gst_C') {
            setocGstStatus(!ocgstStatus);
            if (e.target.checked) {
                setocIncludeGstShow(true)
                setinvoicedetails({ ...invoicedetails, [e.target.name]: 1 })
            } else {
                setocIncludeGstShow(false)
                setinvoicedetails({ ...invoicedetails, [e.target.name]: 0 })
            }
        } else if (e.target.name === 'OC_Gst_C1') {
            setocGstStatus1(!ocgstStatus1);
            if (e.target.checked) {
                setocIncludeGst1Show(true)
                setinvoicedetails({ ...invoicedetails, [e.target.name]: 1 })
            } else {
                setocIncludeGst1Show(false)
                setinvoicedetails({ ...invoicedetails, [e.target.name]: 0 })
            }
        } else if (e.target.name === 'OC_Gst_C2') {
            setocGstStatus2(!ocgstStatus2);
            if (e.target.checked) {
                setocIncludeGst2Show(true)
                setinvoicedetails({ ...invoicedetails, [e.target.name]: 1 })
            } else {
                setocIncludeGst2Show(false)
                setinvoicedetails({ ...invoicedetails, [e.target.name]: 0 })
            }
        }
        else if (e.target.name === 'Include_Gst_C' || e.target.name === 'OC_Include_Gst_C' || e.target.name === 'OC_Include_Gst_C1' || e.target.name === 'OC_Include_Gst_C2' || e.target.name === 'Tuition_Fess_Collected' || e.target.name === 'Enrollment_Fees_Collected' || e.target.name === 'Material_Cost_Collected') {

            if (e.target.name === 'Include_Gst_C') setIncludeGst(!includeGst)
            if (e.target.name === 'OC_Include_Gst_C') setocIncludeGst(!ocincludeGst)
            if (e.target.name === 'OC_Include_Gst_C1') setocIncludeGst1(!ocincludeGst1)
            if (e.target.name === 'OC_Include_Gst_C2') setocIncludeGst2(!ocincludeGst2)
            if (e.target.name === 'Tuition_Fess_Collected') settfCollected(!tfCollected)
            if (e.target.name === 'Enrollment_Fees_Collected') setefCollected(!efCollected)
            if (e.target.name === 'Material_Cost_Collected') setmfCollected(!mfCollected)

            if (e.target.checked) setinvoicedetails({ ...invoicedetails, [e.target.name]: 1 })
            else setinvoicedetails({ ...invoicedetails, [e.target.name]: 0 })
        }
        else setinvoicedetails({ ...invoicedetails, [e.target.name]: e.target.value })
    }

    const handleCalculation = (e) => {
        setcalculateFlag(false)
        let CommissionAmount = 0; // done
        let ComissionGST = 0; // done
        let SubTotal = 0; // done
        let OCAmount = 0; // done
        let OCAmount1 = 0; // done
        let OCAmount2 = 0; // done
        let OCGST = 0; // done
        let OCGST1 = 0; // done
        let OCGST2 = 0; // done
        let FSubTotal = 0;
        let TotalGST = 0;
        let PayableToCollege = 0;

        // Invoice Commission Calculation
        if (invoicedetails.Gst_C === 1) {
            if (invoicedetails.Include_Gst_C === 1) {
                let rec = parseFloat((invoicedetails.Commisionable_Amount * invoicedetails.Comission_percent) / 100);
                let rec1 = (rec / ((gstperc + 100) / 100)).toFixed(2)
                CommissionAmount = rec1;
                ComissionGST = ((CommissionAmount * gstperc) / 100).toFixed(2);
            } else {
                CommissionAmount = parseFloat((invoicedetails.Commisionable_Amount * invoicedetails.Comission_percent) / 100).toFixed(2);
                ComissionGST = parseFloat((CommissionAmount * gstperc) / 100).toFixed(2);
            }
        } else {
            CommissionAmount = parseFloat((invoicedetails.Commisionable_Amount * invoicedetails.Comission_percent) / 100).toFixed(2);
            ComissionGST = 0;
        }

        // SubTotal of Fees Calculation
        SubTotal = parseInt(invoicedetails.Tuition_Fees) + parseInt(invoicedetails.Enrollment_Fees) + parseInt(invoicedetails.Material_Cost) + parseInt(invoicedetails.COE_Fees) + parseInt(invoicedetails.Other_Fees)

        // Invoice Other Commission 1 Calculation
        if (invoicedetails.OC_Gst_C === 1) {
            if (invoicedetails.OC_Include_Gst_C === 1) {
                let rec1 = (invoicedetails.OC_Amount_B / ((gstperc + 100) / 100)).toFixed(2)
                OCAmount = rec1;
                OCGST = ((OCAmount * gstperc) / 100).toFixed(2);
            } else {
                OCAmount = (invoicedetails.OC_Amount_B)
                OCGST = parseFloat((OCAmount * gstperc) / 100).toFixed(2);
            }
        } else {
            OCAmount = (invoicedetails.OC_Amount_B)
            OCGST = 0;
        }

        // Invoice Other Commission 2 Calculation
        if (invoicedetails.OC_Gst_C1 === 1) {
            if (invoicedetails.OC_Include_Gst_C1 === 1) {
                let rec1 = (invoicedetails.OC_Amount_B1 / ((gstperc + 100) / 100)).toFixed(2)
                OCAmount1 = rec1;
                OCGST1 = ((OCAmount1 * gstperc) / 100).toFixed(2);
            } else {
                OCAmount1 = (invoicedetails.OC_Amount_B1)
                OCGST1 = parseFloat((OCAmount1 * gstperc) / 100).toFixed(2);
            }
        } else {
            OCAmount1 = (invoicedetails.OC_Amount_B1)
            OCGST1 = 0;
        }

        // Invoice Other Commission 3 Calculation
        if (invoicedetails.OC_Gst_C2 === 1) {
            if (invoicedetails.OC_Include_Gst_C2 === 1) {
                let rec1 = (invoicedetails.OC_Amount_B2 / ((gstperc + 100) / 100)).toFixed(2)
                OCAmount2 = rec1;
                OCGST2 = ((OCAmount2 * gstperc) / 100).toFixed(2);
            } else {
                OCAmount2 = (invoicedetails.OC_Amount_B2)
                OCGST2 = parseFloat((OCAmount2 * gstperc) / 100).toFixed(2);
            }
        } else {
            OCAmount2 = (invoicedetails.OC_Amount_B2)
            OCGST2 = 0;
        }

        // Final SubTotal of Commission.
        FSubTotal = parseFloat(CommissionAmount) + parseFloat(OCAmount) + parseFloat(OCAmount1) + parseFloat(OCAmount2)

        // Final TotalGST of Commission.
        TotalGST = parseFloat(ComissionGST) + parseFloat(OCGST) + parseFloat(OCGST1) + parseFloat(OCGST2)

        // Final Commission Total with GST.
        let TotalwithGST = FSubTotal + TotalGST;

        // Payable to College.
        let tfv = 0, efv = 0, mfv = 0, tcwgv = 0;
        tfv = parseFloat(invoicedetails.Tuition_Fees)
        efv = parseFloat(invoicedetails.Enrollment_Fees)
        mfv = parseFloat(invoicedetails.Material_Cost)
        tcwgv = parseFloat(TotalwithGST)

        if (tfCollected) {
            if (efCollected) {
                if (mfCollected) PayableToCollege = tfv + efv + mfv - tcwgv
                else PayableToCollege = tfv + efv - tcwgv
            } else PayableToCollege = tfv - tcwgv
        } else if (efCollected) {
            if (tfCollected) {
                if (mfCollected) PayableToCollege = efv + tfv + mfv - tcwgv
                else PayableToCollege = efv + tfv - tcwgv
            } else PayableToCollege = efv - tcwgv
        } else if (mfCollected) {
            if (efCollected) {
                if (tfCollected) PayableToCollege = mfv + efv + tfv - tcwgv
                else PayableToCollege = mfv + efv - tcwgv
            } else PayableToCollege = mfv - tcwgv
        } else {
            PayableToCollege = 0
        }

        // Displaying Calculation.
        setinvoicedetails({
            ...invoicedetails,
            Comission_Amount: CommissionAmount,
            Comission_GST: ComissionGST,
            Sub_Total: SubTotal,
            OC_Amount: OCAmount,
            OC_Amount1: OCAmount1,
            OC_Amount2: OCAmount2,
            OC_GST: OCGST,
            OC_GST1: OCGST1,
            OC_GST2: OCGST2,
            F_Sub_Total: FSubTotal.toFixed(2),
            Total_GST: TotalGST.toFixed(2),
            Total_with_GST: TotalwithGST.toFixed(2),
            Payable_To_College: PayableToCollege.toFixed(2)
        })
    }

    const onInputChange = (e) => {
        const re = /^[0-9\b]+$/;
        if (re.test(e.target.value)) {
        } else {
            return false
        }
    }

    const openOtherCommission1 = () => {
        setoc1(!oc1)
        setcalculateFlag(true)
        setinvoicedetails({ ...invoicedetails, OC_Amount_B1: 0 })
    }

    const openOtherCommission2 = () => {
        setoc2(!oc2)
        setcalculateFlag(true)
        setinvoicedetails({ ...invoicedetails, OC_Amount_B2: 0 })
    }

    const handleClick = (e) => {
        e.preventDefault();
        if (!calculateFlag) {
            dispatch(createInvoice({ ...invoicedata, ...invoicedetails, Invoice_Type_Id: 1 }))
        }
        else setmodErr('Calculate before Saving');
    }

    const handleCountryChange = (e) => {
        if (e.target.value === '13') {
            setgstperc(10)
            setSymbol('$')
        } else if (e.target.value === '108') {
            setgstperc(18)
            setSymbol('₹')
        } else if (e.target.value === '171') {
            setgstperc(13)
            setSymbol('₹')
        } else {
            setgstperc(0)
            setSymbol('$')
        }
    }

    useEffect(() => {
        if (success) {
            dispatch(listInvoices({
                Invoice_Type_Id: '',
                Invoice_Id: '',
                Deal_Id: '',
                Contact_Id: ''
            }))
        }
    }, [dispatch, success])

    const [invoiceMultiple, setInvoiceMultiple] = useState(0)
    const [invoiceMultipleDate, setInvoiceMultipleDate] = useState("")

    const [modErr, setmodErr] = useState("")
    const [modSuc, setmodSuc] = useState("")

    const [showModal, setShowModal] = useState(false)
    const handleClose = () => setShowModal(false);
    const handleMultiplClick = (e) => {
        setShowModal(true);
        setInvoiceMultiple('')
        setInvoiceMultipleDate('')
        setmodErr('')
    }

    const handleMultipleSave = (e) => {
        let errMsg = ''
        if (!calculateFlag) {
            if (invoiceMultiple == '' || invoiceMultiple == undefined) errMsg += 'Please select the number of Invoice you wish to create.<br/>'
            if (invoiceMultipleDate == '' || invoiceMultipleDate == undefined) errMsg += 'Please select the date difference of each invoice.'

            if (errMsg == '') {
                dispatch(createInvoice({ ...invoicedata, ...invoicedetails, Invoice_Type_Id: 1 }))
                for (let i = 0; i < invoiceMultiple; i++) {
                    const datePlus1 = new Date(invoicedata.Invoice_Date).getTime()
                    const dt1 = datePlus1 + ((i + 1) * invoiceMultipleDate * 24 * 60 * 60 * 1000)
                    const dt2 = format((new Date(dt1)), 'yyyy-MM-dd')

                    const datePlus2 = new Date(invoicedata.Invoice_Due_Date).getTime()
                    const dt3 = datePlus2 + ((i + 1) * invoiceMultipleDate * 24 * 60 * 60 * 1000)
                    const dt4 = format((new Date(dt3)), 'yyyy-MM-dd')

                    dispatch(createInvoice({ ...invoicedata, ...invoicedetails, Invoice_Date: dt2, Invoice_Due_Date: dt4, Referral_No: '', Selected_Terms: 0, Invoice_Status: 3, Invoice_Type_Id: 1 }))
                }
                setmodSuc(success)
                setTimeout(() => {
                    setShowModal(false);
                    setmodSuc('')
                }, 3000);
            }
            else setmodErr(errMsg)
        } else setmodErr('Calculate before Saving');
    }

    return (
        <>
            <Header pageName="Add Invoice" />
            <LeftComponent />

            <ModalPopup show={showModal} handleClose={handleClose} header={
                <>
                    <strong>Select Extra Number of Invoices and Date Difference between invoices to create multiple invoices for future.</strong>
                </>
            }
                body={
                    <>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-md-6'>
                                    <select type="text" name="invoiceMultiple" className="form-control form-control-sm" value={invoiceMultiple} onChange={(e) => setInvoiceMultiple(e.target.value)}>
                                        <option value="">--Select No. of Invoices--</option>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                        <option value="4">4</option>
                                        <option value="5">5</option>
                                        <option value="6">6</option>
                                        <option value="7">7</option>
                                        <option value="8">8</option>
                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <select type="text" name="invoiceMultiple" className="form-control form-control-sm" value={invoiceMultipleDate} onChange={e => setInvoiceMultipleDate(e.target.value)}>
                                        <option value="">--Select days--</option>
                                        <option value="30">30 days</option>
                                        <option value="45">45 days</option>
                                        <option value="60">60 days</option>
                                        <option value="75">75 days</option>
                                        <option value="90">90 days</option>
                                        <option value="105">105 days</option>
                                        <option value="120">120 days</option>
                                        <option value="135">135 days</option>
                                        <option value="150">150 days</option>
                                        <option value="165">165 days</option>
                                        <option value="180">180 days</option>
                                    </select>
                                </div>
                                <div className='col-md-12'>
                                    <br />
                                    <span className='text-danger' dangerouslySetInnerHTML={{ __html: modErr }} ></span>
                                    <span className='text-success' dangerouslySetInnerHTML={{ __html: modSuc }} ></span>
                                </div>
                            </div>
                        </div>
                    </>} footer={
                        <>
                            {
                                loading ? (
                                    <>loading...</>
                                ) : (
                                    <>
                                        <button className='btn btn-searcheducation' onClick={handleClose}>Cancel</button>
                                        <button className='btn btn-searcheducation' onClick={handleMultipleSave} >Save</button>
                                    </>
                                )
                            }
                        </>
                    } />

            <div className="content-body">
                <div className="container-fluid">
                    <div className="heading-title">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="home-table-search">
                                    <div className="tasks-page-detail">
                                        <div className="input-group mt-1  pr-5 invoice-title">
                                            {/* <label className="pt-1 mb-0">Invoice Date* &nbsp;</label>
                                            <div className="input-group-prepend">
                                                <span className="input-group-text" id="basic-addon1"><i className="fa fa-calendar"></i></span>
                                            </div>
                                            <input type="text" className="form-control datepicker" name="Invoice_Date" placeholder="DD/MM/YYYY" value={invoicedata.Invoice_Date} onChange={e => handleInvoiceValue(e)} /> */}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="inner-body">
                        <div className="invoice-details">
                            <div className="container">
                                <div id="InvoiceAccordion" className="accordion-invoice">
                                    <div className="card mb-0">
                                        <div className="card-header collapsed" data-toggle="collapse" href="#collapseZero">
                                            <a className="card-title">
                                                Contact Detail
                                            </a>
                                        </div>
                                        <div className="card-body collapse show"  >
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Search Contact* &nbsp; &nbsp;</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <input type="text" className="form-control form-control-sm" placeholder="Search Contact" value={searchKeyword} onChange={e => setSearchKeyword(e.target.value)} />
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Contact* &nbsp; &nbsp;</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <select type="text" name="Contact_Id" className="form-control form-control-sm" value={invoicedata.Contact_Id} onChange={(e) => handleInvoiceValue(e)}>
                                                                <option value="">--Select--</option>
                                                                <Contacts searchtxt={searchKeyword} />
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Deal* &nbsp; &nbsp;</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <select type="text" className="form-control form-control-sm"
                                                                name="Deal_Id"
                                                                value={invoicedata.Deal_Id}
                                                                onChange={e => handleInvoiceValue(e)} >
                                                                <option value="">--Select--</option>
                                                                <Deals contactId={invoicedata.Contact_Id} />
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Application* &nbsp; &nbsp;</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <select type="text" className="form-control form-control-sm"
                                                                name="Application_Id"
                                                                value={invoicedata.Application_Id}
                                                                onChange={(e) => handleInvoiceValue(e)} >
                                                                <option value="">--Select--</option>
                                                                <Applications contactId={invoicedata.Contact_Id} dealId={invoicedata.Deal_Id} />
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Country* &nbsp; &nbsp;</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <select type="text" className="form-control form-control-sm"
                                                                name="Country_Id"
                                                                value={invoicedetails.Country_Id}
                                                                onChange={(e) => { handleInvoiceDetailValue(e); handleCountryChange(e) }} >
                                                                <option value="">--Select--</option>

                                                                <option value='108'>India</option>
                                                                <option value='13'>Australia</option>
                                                                <option value='171'>Nepal</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    {/* <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Invoice Type*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm notification-send">
                                                            <select type="text" className="form-control" name="Invoice_Type_Id" value={invoicedata.Invoice_Type_Id} onChange={e => handleInvoiceValue(e)} >
                                                                <option value="">--Select--</option>
                                                                <InvoiceType />
                                                            </select>
                                                        </div>
                                                    </div> */}

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Referral No.*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm notification-send">
                                                            <input type="text" className="form-control" name="Referral_No" placeholder='referral no' value={invoicedata.Referral_No} onChange={e => handleInvoiceValue(e)} />
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Invoice Status*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm notification-send">
                                                            <select className="form-control" name="Invoice_Status" value={invoicedata.Invoice_Status} onChange={e => handleInvoiceValue(e)} >
                                                                <option value="">--Select--</option>
                                                                <option value="1">Paid</option>
                                                                <option value="2">Partially Paid</option>
                                                                <option value="3">Pending</option>
                                                                <option value="4">Invoiced</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Invoice Date*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm notification-send">

                                                            {/* <div className="input-group-prepend">
                                                                <span onClick={handleInvoiceDate} className="input-group-text" id="basic-addon1"><i className="fa fa-calendar"></i></span>
                                                            </div> */}

                                                            {/* <Datepicker className='form-control'
                                                                name="Invoice_Date"
                                                                onChange={e => handleInvoiceValue(e)}
                                                                value={invoicedata.Invoice_Date}

                                                            /> */}

                                                            <input type="date" className="form-control datepicker" name="Invoice_Date" placeholder="DD/MM/YYYY" value={invoicedata.Invoice_Date} onChange={e => handleInvoiceValue(e)} />
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Invoice Due Date*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm notification-send">
                                                            {/* <div className="input-group-prepend">
                                                                <span className="input-group-text" id="basic-addon1"><i className="fa fa-calendar"></i></span>
                                                            </div> */}

                                                            <input type="date" className="form-control datepicker" name="Invoice_Due_Date" placeholder="DD/MM/YYYY" value={invoicedata.Invoice_Due_Date} onChange={e => handleInvoiceValue(e)} />
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                        {/* Tuition Details Part */}
                                        <div className="card-header collapsed" data-toggle="collapse" href="#collapseOne">
                                            <a className="card-title">
                                                Fees Detail
                                            </a>
                                        </div>
                                        <div className="card-body collapse show"  >
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Total Tuition Fee* &nbsp; &nbsp;</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">{symbol}</span>
                                                            </div>
                                                            <input type="text" className="form-control form-control-sm" name="Total_Tuition_Fees" value={invoicedetails.Total_Tuition_Fees} onChange={(e) => handleInvoiceDetailValue(e)} />
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Total Enrollment Fee* &nbsp; &nbsp;</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">{symbol}</span>
                                                            </div>
                                                            <input type="text" className="form-control form-control-sm" placeholder=""
                                                                name="Total_Enrollment_Fees" value={invoicedetails.Total_Enrollment_Fees} onChange={(e) => handleInvoiceDetailValue(e)} />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Total Material Fee* &nbsp; &nbsp;</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">{symbol}</span>
                                                            </div>
                                                            <input type="text" className="form-control form-control-sm" name="Total_Material_Fees" value={invoicedetails.Total_Material_Fees} onChange={(e) => handleInvoiceDetailValue(e)} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="card-header collapsed" data-toggle="collapse" href="#collapseOne">
                                            <a className="card-title">
                                                Invoice Detail
                                            </a>
                                        </div>
                                        <div className="card-body collapse show"  >
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Term / Year* &nbsp; &nbsp;</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <select type="text" className="form-control form-control-sm" name="Selected_Terms" value={invoicedetails.Selected_Terms} onChange={e => handleInvoiceDetailValue(e)} >
                                                                <option value="0">--Select--</option>
                                                                <TermListComponent />
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Tuition Fee* &nbsp; &nbsp;</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">{symbol}</span>
                                                            </div>
                                                            <input type="text" className="form-control form-control-sm" name="Tuition_Fees" value={invoicedetails.Tuition_Fees} onChange={(e) => handleInvoiceDetailValue(e)} />
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text"><input type="checkbox" name="Tuition_Fess_Collected" checked={tfCollected} onChange={(e) => { handleInvoiceDetailValue(e) }} /> &nbsp; Collected </span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Enrollment Fee* &nbsp; &nbsp;</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">{symbol}</span>
                                                            </div>
                                                            <input type="text" className="form-control form-control-sm" placeholder=""
                                                                name="Enrollment_Fees" value={invoicedetails.Enrollment_Fees} onChange={(e) => handleInvoiceDetailValue(e)} />
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text"><input type="checkbox" name="Enrollment_Fees_Collected" checked={efCollected} onChange={(e) => { handleInvoiceDetailValue(e) }} /> &nbsp; Collected </span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Material Fee* &nbsp; &nbsp;</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">{symbol}</span>
                                                            </div>
                                                            <input type="text" className="form-control form-control-sm" name="Material_Cost" value={invoicedetails.Material_Cost} onChange={(e) => handleInvoiceDetailValue(e)} />
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text"><input type="checkbox" name="Material_Cost_Collected" checked={mfCollected} onChange={(e) => { handleInvoiceDetailValue(e) }} /> &nbsp; Collected </span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">COE Fee* &nbsp; &nbsp;</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">{symbol}</span>
                                                            </div>
                                                            <input type="text" className="form-control form-control-sm"
                                                                name="COE_Fees" value={invoicedetails.COE_Fees} onChange={e => handleInvoiceDetailValue(e)}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Other Fee* &nbsp; &nbsp;</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">{symbol}</span>
                                                            </div>
                                                            <input type="text" className="form-control form-control-sm" name="Other_Fees" value={invoicedetails.Other_Fees} onChange={e => handleInvoiceDetailValue(e)} />
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Sub Total* &nbsp; &nbsp;</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">{symbol}</span>
                                                            </div>
                                                            <input type="text" className="form-control form-control-sm" name="Sub_Total" value={invoicedetails.Sub_Total} onChange={e => handleInvoiceDetailValue(e)} disabled />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Description</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm notification-send">
                                                            <textarea className="form-control form-control-sm" name="Description" value={invoicedetails.Description} onChange={e => handleInvoiceDetailValue(e)}></textarea>
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Commissionable Amount*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">{symbol}</span>
                                                            </div>
                                                            <input type="text" className="form-control form-control-sm" name="Commisionable_Amount" value={invoicedetails.Commisionable_Amount} onChange={(e) => { handleInvoiceDetailValue(e) }} onKeyDown={e => onInputChange(e)} />

                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Commission Percent*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">

                                                            <input type="text" className="form-control form-control-sm" name="Comission_percent" value={invoicedetails.Comission_percent} onChange={(e) => handleInvoiceDetailValue(e)} />
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">%</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Commission Amount*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">{symbol}</span>
                                                            </div>
                                                            <input type="text" className="form-control form-control-sm" name="Comission_Amount" value={invoicedetails.Comission_Amount} onChange={(e) => handleInvoiceDetailValue(e)} disabled />
                                                            {
                                                                includeGstShow ? (
                                                                    <div className="input-group-prepend">
                                                                        <span className="input-group-text">
                                                                            <input type="checkbox" id="Include_Gst_C" name="Include_Gst_C" checked={includeGst}
                                                                                onChange={e => handleInvoiceDetailValue(e)} />
                                                                            &nbsp; Include GST
                                                                        </span>
                                                                    </div>
                                                                ) : (
                                                                    <></>
                                                                )
                                                            }
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Commission GST*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">{symbol}</span>
                                                            </div>
                                                            <input type="text" className="form-control form-control-sm" name="Comission_GST" value={invoicedetails.Comission_GST} onChange={(e) => handleInvoiceDetailValue(e)} disabled />
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text"><input type="checkbox" name="Gst_C" checked={gstStatus} onChange={(e) => handleInvoiceDetailValue(e)} /> &nbsp; GST </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-header collapsed" data-toggle="collapse" data-parent="#InvoiceAccordion" href="#collapseTwo">
                                            <a className="card-title">
                                                Other Commission
                                            </a>

                                            <div className='float-right'>
                                                <a href="javascript:void(0)" onClick={openOtherCommission1}>
                                                    {
                                                        !oc1 ? (<>+ Add 2 </>) : (<>- Remove 2</>)
                                                    }
                                                </a>
                                                &nbsp;&nbsp;&nbsp;
                                                <a href="javascript:void(0)" onClick={openOtherCommission2}>
                                                    {
                                                        !oc2 ? (<>+ Add 3 </>) : (<>- Remove 3</>)
                                                    }
                                                </a>
                                            </div>
                                        </div>

                                        {/* Other Commission 1 */}
                                        <div className="card-body collapse show" data-parent="#InvoiceAccordion" >
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Amount*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">{symbol}</span>
                                                            </div>
                                                            <input type="text" className="form-control form-control-sm" name="OC_Amount_B" value={invoicedetails.OC_Amount_B} onChange={e => handleInvoiceDetailValue(e)} />
                                                        </div>
                                                    </div>
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Amount*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">{symbol}</span>
                                                            </div>
                                                            <input type="text" className="form-control form-control-sm" name="OC_Amount" value={invoicedetails.OC_Amount} onChange={e => handleInvoiceDetailValue(e)} disabled />
                                                            {
                                                                ocincludeGstShow ? (
                                                                    <div className="input-group-prepend">
                                                                        <span className="input-group-text"><input type="checkbox" id="OC_Include_Gst_C"
                                                                            name="OC_Include_Gst_C"
                                                                            checked={ocincludeGst}
                                                                            onChange={e => handleInvoiceDetailValue(e)} /> &nbsp; Include GST </span>
                                                                    </div>
                                                                ) : (
                                                                    <></>
                                                                )
                                                            }
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">GST*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">{symbol}</span>
                                                            </div>
                                                            <input type="text" className="form-control form-control-sm" name="OC_GST" value={invoicedetails.OC_GST} onChange={e => handleInvoiceDetailValue(e)} disabled />
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text"><input type="checkbox" name="OC_Gst_C" checked={ocgstStatus} onChange={e => handleInvoiceDetailValue(e)} /> &nbsp; GST </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">&nbsp;</div>
                                                        <div className='col-md-8'>&nbsp;</div>
                                                    </div>
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Description</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm notification-send">
                                                            <textarea className="form-control form-control-sm" placeholder="type here..." name="OC_Description" value={invoicedetails.OC_Description} onChange={e => handleInvoiceDetailValue(e)}></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        {/* Other Commission 2 */}
                                        {
                                            oc1 ? (
                                                <div className="card-body collapse show" data-parent="#InvoiceAccordion" >
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="row mt-3">
                                                                <div className="col-sm-4">
                                                                    <label className="pt-1 mb-0">Amount 2 *</label>
                                                                </div>
                                                                <div className="col-sm-8 input-group input-group-sm">
                                                                    <div className="input-group-prepend">
                                                                        <span className="input-group-text">{symbol}</span>
                                                                    </div>
                                                                    <input type="text" className="form-control form-control-sm" name="OC_Amount_B1" value={invoicedetails.OC_Amount_B1} onChange={e => handleInvoiceDetailValue(e)} />
                                                                </div>
                                                            </div>
                                                            <div className="row mt-3">
                                                                <div className="col-sm-4">
                                                                    <label className="pt-1 mb-0">Amount*</label>
                                                                </div>
                                                                <div className="col-sm-8 input-group input-group-sm">
                                                                    <div className="input-group-prepend">
                                                                        <span className="input-group-text">{symbol}</span>
                                                                    </div>
                                                                    <input type="text" className="form-control form-control-sm" name="OC_Amount1" value={invoicedetails.OC_Amount1} onChange={e => handleInvoiceDetailValue(e)} disabled />
                                                                    {
                                                                        ocincludeGst1Show ? (
                                                                            <div className="input-group-prepend">
                                                                                <span className="input-group-text"><input type="checkbox" id="OC_Include_Gst_C1"
                                                                                    name="OC_Include_Gst_C1"
                                                                                    checked={ocincludeGst1}
                                                                                    onChange={e => handleInvoiceDetailValue(e)} /> &nbsp; Include GST </span>
                                                                            </div>
                                                                        ) : (
                                                                            <></>
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>

                                                            <div className="row mt-3">
                                                                <div className="col-sm-4">
                                                                    <label className="pt-1 mb-0">GST*</label>
                                                                </div>
                                                                <div className="col-sm-8 input-group input-group-sm">
                                                                    <div className="input-group-prepend">
                                                                        <span className="input-group-text">{symbol}</span>
                                                                    </div>
                                                                    <input type="text" className="form-control form-control-sm" name="OC_GST1" value={invoicedetails.OC_GST1} onChange={e => handleInvoiceDetailValue(e)} disabled />
                                                                    <div className="input-group-prepend">
                                                                        <span className="input-group-text"><input type="checkbox" name="OC_Gst_C1" checked={ocgstStatus1} onChange={e => handleInvoiceDetailValue(e)} /> &nbsp; GST </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6">
                                                            <div className="row mt-3">
                                                                <div className="col-sm-4">&nbsp;</div>
                                                                <div className='col-md-8'>&nbsp;</div>
                                                            </div>
                                                            <div className="row mt-3">
                                                                <div className="col-sm-4">
                                                                    <label className="pt-1 mb-0">Description</label>
                                                                </div>
                                                                <div className="col-sm-8 input-group input-group-sm notification-send">
                                                                    <textarea className="form-control form-control-sm" placeholder="type here..." name="OC_Description1" value={invoicedetails.OC_Description1} onChange={e => handleInvoiceDetailValue(e)}></textarea>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <></>
                                            )
                                        }

                                        {/* Other Commission 3 */}
                                        {
                                            oc2 ? (
                                                <div className="card-body collapse show" data-parent="#InvoiceAccordion" >
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="row mt-3">
                                                                <div className="col-sm-4">
                                                                    <label className="pt-1 mb-0">Amount 3*</label>
                                                                </div>
                                                                <div className="col-sm-8 input-group input-group-sm">
                                                                    <div className="input-group-prepend">
                                                                        <span className="input-group-text">{symbol}</span>
                                                                    </div>
                                                                    <input type="text" className="form-control form-control-sm" name="OC_Amount_B2" value={invoicedetails.OC_Amount_B2} onChange={e => handleInvoiceDetailValue(e)} />
                                                                </div>
                                                            </div>
                                                            <div className="row mt-3">
                                                                <div className="col-sm-4">
                                                                    <label className="pt-1 mb-0">Amount*</label>
                                                                </div>
                                                                <div className="col-sm-8 input-group input-group-sm">
                                                                    <div className="input-group-prepend">
                                                                        <span className="input-group-text">{symbol}</span>
                                                                    </div>
                                                                    <input type="text" className="form-control form-control-sm" name="OC_Amount2" value={invoicedetails.OC_Amount2} disabled />
                                                                    {
                                                                        ocincludeGst2Show ? (
                                                                            <div className="input-group-prepend">
                                                                                <span className="input-group-text"><input type="checkbox" id="OC_Include_Gst_C2"
                                                                                    name="OC_Include_Gst_C2"
                                                                                    checked={ocincludeGst2}
                                                                                    onChange={e => handleInvoiceDetailValue(e)} /> &nbsp; Include GST </span>
                                                                            </div>
                                                                        ) : (
                                                                            <></>
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>

                                                            <div className="row mt-3">
                                                                <div className="col-sm-4">
                                                                    <label className="pt-1 mb-0">GST*</label>
                                                                </div>
                                                                <div className="col-sm-8 input-group input-group-sm">
                                                                    <div className="input-group-prepend">
                                                                        <span className="input-group-text">{symbol}</span>
                                                                    </div>
                                                                    <input type="text" className="form-control form-control-sm" name="OC_GST2" value={invoicedetails.OC_GST2} onChange={e => handleInvoiceDetailValue(e)} disabled />
                                                                    <div className="input-group-prepend">
                                                                        <span className="input-group-text"><input type="checkbox" name="OC_Gst_C2" checked={ocgstStatus2} onChange={e => handleInvoiceDetailValue(e)} /> &nbsp; GST </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6">
                                                            <div className="row mt-3">
                                                                <div className="col-sm-4">&nbsp;</div>
                                                                <div className='col-md-8'>&nbsp;</div>
                                                            </div>
                                                            <div className="row mt-3">
                                                                <div className="col-sm-4">
                                                                    <label className="pt-1 mb-0">Description</label>
                                                                </div>
                                                                <div className="col-sm-8 input-group input-group-sm notification-send">
                                                                    <textarea className="form-control form-control-sm" placeholder="type here..." name="OC_Description2" value={invoicedetails.OC_Description2} onChange={e => handleInvoiceDetailValue(e)}></textarea>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <></>
                                            )
                                        }


                                        {/* Total Commission */}
                                        <div className="card-header collapsed" data-toggle="collapse" data-parent="#InvoiceAccordion" href="#collapseThree">
                                            <a className="card-title">
                                                Total Commission
                                            </a>
                                        </div>
                                        <div className="card-body collapse show" data-parent="#InvoiceAccordion" >
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Sub Total*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">{symbol}</span>
                                                            </div>
                                                            <input type="text" className="form-control form-control-sm" name="F_Sub_Total" value={invoicedetails.F_Sub_Total} onChange={e => handleInvoiceDetailValue(e)} disabled />
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Total GST*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">{symbol}</span>
                                                            </div>
                                                            <input type="text" className="form-control form-control-sm" name="Total_GST" value={invoicedetails.Total_GST} onChange={e => handleInvoiceDetailValue(e)} disabled />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Total with GST</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">{symbol}</span>
                                                            </div>
                                                            <input type="text" className="form-control form-control-sm" name="Total_with_GST" value={invoicedetails.Total_with_GST} onChange={e => handleInvoiceDetailValue(e)} disabled />
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Payable To College</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">{symbol}</span>
                                                            </div>
                                                            <input type="text" className="form-control form-control-sm" name="Payable_To_College" value={invoicedetails.Payable_To_College} onChange={e => handleInvoiceDetailValue(e)} disabled />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="card-header collapsed" data-toggle="collapse" data-parent="#InvoiceAccordion" href="#collapseFour">
                                            <a className="card-title">
                                                Payment Details
                                            </a>
                                        </div>
                                        <div className="card-body collapse show" data-parent="#InvoiceAccordion" >
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Payment Medium*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <select type="text" className="form-control form-control-sm" name="Medium_Type" value={invoicedetails.Medium_Type} onChange={e => handleInvoiceDetailValue(e)} >
                                                                <option value="">--Select--</option>
                                                                <option value="1">Cash</option>
                                                                <option value="2">Online</option>
                                                                <option value="3">Credit Card</option>
                                                                <option value="4">Debit Card</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Medium Description</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">

                                                            <input type="text" className="form-control form-control-sm" placeholder='describe here...' name="Medium_Description" value={invoicedetails.Medium_Description} onChange={e => handleInvoiceDetailValue(e)} />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-12 text-center">
                                                    <hr />
                                                    {
                                                        loading ? (
                                                            <>loading...</>
                                                        ) : (
                                                            <>
                                                                <div className="Create-btn">
                                                                    {
                                                                        calculateFlag ? (
                                                                            <><button type="button" className="btn btn-searcheducation" onClick={handleCalculation}>Calculate</button> &nbsp; &nbsp;</>
                                                                        ) : (
                                                                            <><button type="button" className="btn btn-searcheducation" onClick={e => handleClick(e)}>Save</button> &nbsp; &nbsp;
                                                                                <button type="button" className="btn btn-searcheducation" onClick={e => handleMultiplClick(e)}>Save and Replicate</button></>
                                                                        )
                                                                    }


                                                                </div>
                                                                <span className='text-success'>{success}</span>
                                                                <span className='text-danger'>{error}</span>
                                                            </>
                                                        )
                                                    }

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
